import React from 'react';

import { List, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface CallerInformationProps {
  phoneNumber?: string;
}
export function CallerInformation({ phoneNumber }: CallerInformationProps) {
  const { t } = useTranslation();

  if (!phoneNumber) {
    return (
      <Text size="sm" weight={500}>
        {t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALLER_INFORMATION_SECTION.EMPTY_STATE')}
      </Text>
    );
  }

  return (
    <List>
      <List.Item>
        <Text size="sm" weight={500}>
          {t('SMART_ASSISTANT.VOICE_CALLS_SECTION.SUMMARY_TAB.CALLER_INFORMATION_SECTION.PHONE_NUMBER', {
            phoneNumber
          })}
        </Text>
      </List.Item>
    </List>
  );
}
